<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>   
    <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
    <div class="main-wrapper" :class="{'blur-content': this.isLoading}">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->
 

      <div class="page-wrapper">

          <!--begin::content-->
          <div class="page-content">
            <div class="row">
              <div>
                <h4 class="mb-12 mb-md-0"></h4>
              </div>
  
              <div class="col-lg-12 col-xl-12 stretch-card">
                <div class="card">
                  <div class="card-header">
                    <h4 style="margin-right: 5px" class="float-start">Detail Billing</h4>
                   
  
                  </div> 

                  <div class="card-body">
                     

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">Job No</label>
                      </div>
                      <div class="col-lg-8">
                       
                        <input
                          type="text"
                          class="form-control"
                          id="name"
                          v-model="forms.job_no"
                          readonly
                        />
                        
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">Job Date</label>
                      </div>
                      <div class="col-lg-8">
                       
                        <input
                          type="text"
                          class="form-control"
                          id="name"
                          v-model="forms.job_date"
                          readonly
                        />
                        
                      </div>
                    </div>
                    
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">Customer Code</label>
                      </div>
                      <div class="col-lg-8">
                       
                        <input
                          type="text"
                          class="form-control"
                          id="name"
                          v-model="forms.customer_cd"
                          readonly
                        />
                        
                      </div>
                    </div>

                    
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">Customer Name</label>
                      </div>
                      <div class="col-lg-8">
                       
                        <input
                          type="text"
                          class="form-control"
                          id="name"
                          v-model="forms.customer_nm"
                          readonly
                        />
                        
                      </div>
                    </div>

                    
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="shipper" class="col-form-label" style="padding-left: 25px">Shipper</label>
                      </div>
                      <div class="col-lg-8">
                       
                        <input
                          type="text"
                          class="form-control"
                          id="name"
                          v-model="forms.shipper"
                          readonly
                        />
                        
                      </div>
                    </div>

                    
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="commodity" class="col-form-label" style="padding-left: 25px">Commodity</label>
                      </div>
                      <div class="col-lg-8">
                       
                        <input
                          type="text"
                          class="form-control"
                          id="name"
                          v-model="forms.commodity"
                          readonly
                        />
                        
                      </div>
                    </div>

                    
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="create_by" class="col-form-label" style="padding-left: 25px">Create By</label>
                      </div>
                      <div class="col-lg-8">
                       
                        <input
                          type="text"
                          class="form-control"
                          id="name"
                          v-model="forms.create_by"
                          readonly
                        />
                        
                      </div>
                    </div>

                    
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="update_by" class="col-form-label" style="padding-left: 25px">Update By</label>
                      </div>
                      <div class="col-lg-8">
                       
                        <input
                          type="text"
                          class="form-control"
                          id="name"
                          v-model="forms.update_by"
                          readonly
                        />
                        
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="created_at" class="col-form-label" style="padding-left: 25px">Create At</label>
                      </div>
                      <div class="col-lg-8">
                       
                        <input
                          type="text"
                          class="form-control"
                          id="name"
                          v-model="forms.created_at"
                          readonly
                        />
                        
                      </div>
                    </div>

                    
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="updated_at" class="col-form-label" style="padding-left: 25px">Update At</label>
                      </div>
                      <div class="col-lg-8">
                       
                        <input
                          type="text"
                          class="form-control"
                          id="name"
                          v-model="forms.updated_at"
                          readonly
                        />
                        
                      </div>
                    </div>

                    
                    <div class="row mb-3">
                      <div class="col-lg-12">

                        <label for="updated_at" class="col-form-label" style="padding-left: 25px">Details</label>
                        
                        <table class="table table-striped">

                            <thead>

                                <tr>
                                    <th>No</th>
                                    <th>Settlement Id</th>
                                    <th>Product Id</th>
                                    <th>product name</th>
                                    <th>product category</th>
                                    <th>Remarks</th>
                                    <th>qty</th>
                                    <th>rate</th>
                                </tr>

                            </thead>
                            <tbody v-if="form_details.length > 0">
 
                                    <tr v-for="(item, index) in this.form_details" :key="item.exim_bill_detail_id">
                                        <td>{{ index+1 }}</td>
                                        <td>{{ item.settlement_id }}</td>
                                        <td>{{ item.product_id }}</td>
                                        <td>{{ item.product_name }}</td>
                                        <td>{{ item.product_category }}</td>
                                        <td>{{ item.remarks }}</td>
                                        <td>{{ item.qty }}</td>
                                        <td>{{ formatIDR(item.rate) }}</td>
                                    </tr>
                                    

                            </tbody>

                        </table>



                      </div>
                      
                    </div>


                  </div>
 


                    <div class="card-footer">
                      <button
                        class="
                          btn btn-warning
                          text-black
                          fw-bolder
                          btn-icon-text
                        "
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>
 
                    </div>
 

                </div>
              </div>
            </div>
          </div>
          <!--end::content-->
   

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
 

  </div>
</template>
  
  
<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";


export default {
    name: "EximBillingDetail",
    props: {},
    components: {

        "navbar-component": navbarComponent,
        "footer-component": footerComponent,

    },
    data() {

        return {
            permision_role: [],
            isLoading: false,
            maxToasts: 100,
            position: "up right",
            closeBtn: true,
            errors: [],
            userData: "",
            userRole: "",
            forms: {
                exim_bill_header_id:"",
                job_no:"",
                job_date:"",
                customer_nm:"",
                filename:"",
                create_by:"",
                update_by:"",
                shipper:"",
                commodity:"",
                created_at:"",
                updated_at:"",
            }, 
            form_details: [], 
        };
    },
    watch: {},
    methods: {
    
        loadData(id) {
          this.isLoading = true;
  
          const baseURI = this.$settings.endPointBlujay + "api/new-dashboard/exim/billing/detail/" + id;
          return this.$http.get(baseURI,{ timeout: 10000 }).then((response) => {
          this.isLoading = false;
              this.forms = response.data.datas;

              this.form_details=response.data.datas.exim_details;

          }).catch(error => {
            this.isLoading = false;
            if(error.code == "ECONNABORTED"){
                this.error("Please Check Your Internet Connection");
            }else{

                if(error.code == "ECONNABORTED"){
                this.error("Please Check Your Internet Connection");
                }
        
                if (error.response) {
                if(error.response.status === 422) {
                        this.errors = error.response.data.errors;
                        this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
                }
                
            }


          });
        },
        
        backForm() {
            window.location.href = "/billing/exim/transaction";
        },

        
        formatIDR(value) {
          return new Intl.NumberFormat('id-ID', {
            style: 'currency',
            currency: 'IDR',
            minimumFractionDigits: 0, // Removes .00 if not needed
          }).format(value);

        }, 
 

        fetchIt() {
            const userDatas = this.$getUserInfo();
            this.userData = userDatas.sub;
            this.userRole = userDatas.sub.role;
            // this.permision_role = userDatas.sub.permision_role;
            let rolePermision = [];
            userDatas.sub.permision_role.forEach(function (permision) {
                if (permision.permission.controller == 'EximBillingController') {
                    rolePermision = permision;
                }
            });

            if (!rolePermision.method_read) {
                this.$router.push("/authorized-error");
            }

            this.permision_role = rolePermision;
            var params = this.$onBehind(this.$route.params.id);
            this.loadData(params[0]);

        },

        logout() {

            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

                console.log(response);

            });

            this.$logoutUser();
            window.location.href = '/';
        },

        fade(sType) {
            this.isLoading = sType;
        },

        loading() {
            this.fade(true);
            setTimeout(() => {
                this.fade(false);
            }, 1000); // hide the message after 3 seconds
        },

        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
            }
        },

        success(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "success",
                title: kata,
            });
        },

        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },
 

    },
    events: {},
    created: function () { },
    mounted() {

        this.fetchIt();

    },
};
</script>
<style scoped>.required:after {
  content: " *";
  color: red;
}</style>